import moment from 'moment';
import routineLogo from 'assets/images/short-lighto-logo.png';
import last from 'lodash/last';
import { lotDatePattern } from 'constants/constants';

// const LOT_DATE_PROMOTIONS = {
//   thefaceshop: ['7152', '7157', '7154'],
//   beautybox: [
//     '9722',
//     '9723',
//     '9726',
//     '9727',
//     '9728',
//     '9729',
//     '9730',
//     '9731',
//     '9732',
//     '9735',
//   ],
// };

const logoBase64Data = {};

const getLotDateAlertNote = (variant) => {
  // if (!LOT_DATE_PROMOTIONS[chainStore?.id]) return '';
  // if (
  //   item?.promotionInfos?.find((e) =>
  //     LOT_DATE_PROMOTIONS[chainStore?.id].includes?.(e.promotionId),
  //   )
  // )
  //   return 'CLEAR DATE';
  const lotDate: string = last(variant?.sku?.split('_'));
  const isHasLotDate = lotDatePattern.test(lotDate);
  const month = !isHasLotDate
    ? null
    : Number(lotDate?.replace('M', '')?.replace('m', ''));

  if (!month) return '';
  if (month < 0) return 'outdate';
  if (month <= 3) return '< 3 tháng';
  if (month <= 6) return '< 6 tháng';
  if (month <= 9) return '< 9 tháng';
  if (month <= 12) return '< 12 tháng';
  return '';
};

export const formatChunkedItems = (items) =>
  Object.values(
    items?.reduce(
      (e, key) => ({
        ...e,
        [key?.variantId || key?.variant?.id || key?.variantSku]: {
          ...e?.[key?.variantId || key?.variant?.id || key?.variantSku],
          ...key,
          quantity:
            key?.quantity +
            (e?.[key?.variantId || key?.variant?.id || key?.variantSku]
              ?.quantity || 0),
        },
      }),
      {},
    ) || {},
  );

const getTotal = (items) => {
  let total = 0;

  items.forEach((e) => {
    total += e?.quantity;
  });

  return total;
};

const getUom = (item) => {
  switch (item?.UomId) {
    case 'PAIR':
      return 'Đôi';
    case 'PCS':
    default:
      return 'Cái';
  }
};
const PRINT_PER_PAGE_HEIGHT = 1228;
const PRINT_PAGE_HEIGHT = 'height: 32.5cm;';

const getBase64 = async (url) => {
  try {
    if (logoBase64Data[url]) return logoBase64Data[url];
    // return url;le
    const controller = new AbortController();

    // 5 second timeout:
    const timeoutId = setTimeout(() => {
      controller.abort();
      clearTimeout(timeoutId);
    }, 40000);

    const response = await fetch(url, {
      cache: 'no-cache',
      mode: 'cors',
      credentials: 'omit',
      signal: controller.signal,
    });

    const image = await response.blob();
    // const raw = Buffer.from(image).toString('base64');
    const objectURL = URL.createObjectURL(image);
    logoBase64Data[url] = objectURL;
    clearTimeout(objectURL);
    return objectURL;
  } catch (error) {
    console.log(error);
    return '';
  }
};

export const genOrderTemplate = (_order, batch) => {
  return new Promise((resolve) => {
    const order = {
      ..._order,
      items: formatChunkedItems(_order?.items || []) || [],
      promotionNote: _order.promotionInfos
        ?.map((e) => e?.detail?.[0]?.message || e?.detail?.[1]?.message)
        .filter((e) => e)
        .join('<br/>'),
    };
    const template = genOrderTemplateOneSide(order, batch, true, null);
    const elm = document.createElement('div');
    elm.id = `page-${order.id}`;
    elm.innerHTML = template;
    document.getElementById('print-preview').append(elm);
    setTimeout(() => {
      const actualHeight = document.getElementById(
        `page-${order.id}`,
      ).clientHeight;
      if (actualHeight < PRINT_PER_PAGE_HEIGHT) {
        // document.getElementById('print-preview').style.height = PRINT_PER_PAGE_HEIGHT;
        // console.log(document.getElementById('print-preview').innerHTML)
        document.getElementById('print-preview').removeChild(elm);
        getBase64(order?.chainStore?.logo || routineLogo).then((base64Data) => {
          resolve(genOrderTemplateOneSide(order, batch, false, base64Data));
        });

        return;
      }
      const items = document.getElementsByClassName(`${order?.id}-item`);
      const splitIndex = [];
      const bodyRect = document
        .getElementById(`page-${order.id}`)
        .getBoundingClientRect();

      const numOfPage =
        (actualHeight - (actualHeight % PRINT_PER_PAGE_HEIGHT)) /
          PRINT_PER_PAGE_HEIGHT +
        (actualHeight / PRINT_PER_PAGE_HEIGHT > 1 ? 1 : 0);

      for (let i = 0; i < items.length; i += 1) {
        const rect = items[i].getBoundingClientRect();
        if (
          rect.top - bodyRect.top + rect.height >
          PRINT_PER_PAGE_HEIGHT * (splitIndex.length + 1) -
            (splitIndex.length ? 100 : 0)
        ) {
          splitIndex.push(i);
          if (splitIndex.length === numOfPage) break;
        }
      }

      const sumRect = document
        .getElementById(`sum-items-${order.id}`)
        .getBoundingClientRect();

      if (
        numOfPage === 2 &&
        sumRect.top - bodyRect.top + sumRect.height < PRINT_PER_PAGE_HEIGHT
      ) {
        getBase64(order?.chainStore?.logo || routineLogo).then((base64Data) => {
          resolve(
            genOrderTemplateTwoSide(
              order,
              batch,
              splitIndex,
              numOfPage,
              true,
              base64Data,
            ),
          );
        });
        return;
      }
      document.getElementById('print-preview').removeChild(elm);
      getBase64(order?.chainStore?.logo || routineLogo).then((base64Data) => {
        resolve(
          genOrderTemplateTwoSide(
            order,
            batch,
            splitIndex,
            numOfPage,
            undefined,
            base64Data,
          ),
        );
      });
    }, 500);
  });
};

const genOrderTemplateOneSide = (order, batch, isRaw, base64Data) => {
  const batchDate = moment(batch?.createdAt);
  const items = order?.items;
  const template = `<section data-id="${order?.id}" style="position:relative; ${
    !isRaw ? PRINT_PAGE_HEIGHT : ''
  } page-break-after: always;">
 <div  id="page-${order.id}"  style="width: 800px; ${
   !isRaw ? PRINT_PAGE_HEIGHT : ''
 } padding: 40px; font-size: 12px; display: flex; flex-direction: column;">
    <div style="flex-grow: 2;">
       <div style="display:flex;justify-content: space-between;">
          <div style="display:flex;padding: 10px;  justify-content: space-between;">
          <img height="30px" src="${
            base64Data || order?.chainStore?.logo || routineLogo
          }" style="object-fit: contain; margin-top: 20px; margin-right: 20px;" />
          <div style="text-align: left;font-size: 11px; flex-grow: 2;display:flex; align-items:flex-start; flex-direction:column; justify-content:center;">
             <div>
                <strong>${order?.chainStore?.name || 'routine'} Vietnam (${
                  order?.chainStore?.siteUrl || 'routine.com.vn'
                })</strong> Thuộc quyền sở hữu của ${
                  order?.chainStore?.data?.companyName ||
                  'CÔNG TY TM DV TỔNG HỢP HOÀN VŨ'
                }</div>
             <div>${
               order?.chainStore?.data?.address ||
               '294 Hai Bà Trưng, P. Tân Định Q1, TP.HCM'
             }</div>
             <div style="display:flex;">
                <div style="font-size: 11px; display:flex; align-items:center;">
                   ĐT<span>:</span> ${
                     order?.chainStore?.data?.phoneNumber || '18006035'
                   }
                </div>
                <div style="font-size: 11px; display:flex; align-items:center;margin-left: 10px;">
                   Email<span>:</span> ${
                     order?.chainStore?.data?.email || 'support@routine.com.vn'
                   }
                </div>
             </div>
          </div>
       </div>
       <div style="margin-left: 20px;max-width: 45%; display: flex;  text-align: center; flex-direction: column; justify-content: center; align-items: center;">
          <div>Mẫu số: 02-VT</div>
          <div>
             (Ban hành theo TT số 200/2014/TT-BTC ngày 22/12/2014 của Bộ Trưởng BCT)
          </div>
       </div>
    </div>
    <div style="margin: 14px 0px; display: flex; justify-content: space-between;">
       <div style="margin-top: 10px; text-align: left;">
          <div style="font-size:15px; margin-top: 10px;">Mã đơn hàng  <b>${
            order?.orderNumber
          }</b></div>
          <div style="font-size:15px; margin-top: 10px;">Mã OMS  <b>${
            order?.id
          }</b></div>
       </div>
       <div style="text-align:left;">
          <canvas id="sale-order-id-${
            order?.id
          }" class="barcode-delivery-img"></canvas>
          <div style="text-align: center;font-size:15px;">${
            order?.saleOrderId
          }</div>
       </div>
    </div>
    <div>
       <div style="font-size: 20px; font-weight: bold; text-align:center;">PHIẾU XUẤT KHO</div>
       <div style="text-align:center;">
          Ngày ${batchDate.format('D')} tháng ${batchDate.format(
            'M',
          )} năm ${batchDate.format('YYYY')}
       </div>
    </div>
    <br/>
    <div  style="display:flex; align-items:center; justify-content: space-between;">
       <div  style='text-align: left;'>
          Đơn vị vận chuyển: <b>${order?.partner?.name}</b>
          <div>
             Địa chỉ: ${order?.address?.addressLine1 || ''}, ${
               order?.address?.addressLine2 || ''
             }, ${order?.address?.ward || ''}, ${order?.address?.district || ''}, ${
               order?.address?.province || ''
             }
          </div>
       </div>
       
    </div>
    <br />
    <div style='text-align: left;'>
       Kho xuất: ${order?.location?.id} - ${order?.location?.name}
    </div>

    <div style="display: flex; align-items: flex-end;">
       <div style="max-width: 100px; margin-top: 10px;">
       <canvas class="site-qrcode-img" id="site-url-${order?.id}" />
       </div>
       <div style="margin-top: 20px; padding: 0px 20px; text-align: left;">
           Quý khách vui lòng scan QR code hoặc truy cập https://${
             order?.chainStore?.siteUrl || 'routine.com.vn'
           }/help-center/questions để tham khảo quy định đổi trả sản phẩm
      </div>
    </div>
    <table id="items-${
      order.id
    }" style="width: 100%; border: 1px solid black; border-collapse: collapse; margin-top: 20px;">
       <tr>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 30px;">STT</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 120px;">Barcode</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 70px;">Loại</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 80px;">Mã số</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse;">Tên hàng</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Màu</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Size</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">DVT</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 60px;">Số lượng</th>
          <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Ghi chú</th>
       </tr>
       ${items
         ?.map(
           (e, index) =>
             `<tr class="${order?.id}-item" key="${index}">
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
             ${index + 1}
           </td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
             ${(e?.variant?.barCode || e?.barCode || e?.barcode || '')
               ?.split(',')
               ?.map((barCode) => `<div>${barCode}</div>`)
               ?.join('')}
           </td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
             ${
               e?.product?.productType?.detail?.find(
                 (e) => e?.langCode === 'vi',
               )?.name ||
               e?.product?.productType?.detail?.find(
                 (e) => e?.langCode === 'en',
               )?.name ||
               e?.product?.productType?.slug ||
               ''
             }
           </td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
             e?.ItemId || ''
           }</td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
             e?.ItemDescription || ''
           }</td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;"></td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
             e?.VariantId || ''
           }</td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getUom(
             e,
           )}</td>
           <td style="text-align:right; padding-right: 10px; border: 1px solid black;border-collapse: collapse;">${
             e?.quantity
           }</td>
           <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getLotDateAlertNote(
             e?.variant,
           )}</td>
         </tr>`,
         )
         .join('')}
    </table>
    <table id="sum-items-${
      order.id
    }" style="width: 100%; border-collapse: collapse;margin-top: -1px; ">
       <tfoot>
          <tr>
             <td style="border: 1px solid black;border-collapse: collapse; text-align:center; padding:10px 5px;">
                <b>Tổng Cộng</b>
             </td>
             <td style="border: 1px solid black;border-collapse: collapse; width: 60px; text-align:right;">
                <div style="padding-right: 10px;">
                   <b>${getTotal(order?.items)}</b>
                </div>
             </td>
             <td style="border: 1px solid black;border-collapse: collapse; width: 50px;"></td>
          </tr>
       </tfoot>
    </table>
    <br/>
    <div  style='text-align: left;'>
       Ghi chú: ${
         order?.note ||
         '...............................................................................................................................................................................................'
       }
    </div>
    ${
      order?.promotionNote
        ? `<div  style='text-align: left;'>
      Ghi chú quà tặng: <b>${order?.promotionNote}</b>
    </div>`
        : ''
    }
    
    <br />
    <div>
       <br/><br/>
       <div style="display: flex;  text-align: center;">
          <div style="flex:1;">
             <div><b>NHÂN VIÊN KHO</b></div>
             <div>(Ký, họ tên)</div>
          </div>
          <div style="flex:1;">
             <div>
                <b>QUẢN LÝ KHO</b>
             </div>
             <div>(Ký, họ tên)</div>
          </div>
          <div style="flex:1;">
             <div>
                <b>KẾ TOÁN KHO</b>
             </div>
             <div>(Ký, họ tên)</div>
          </div>
          <div  style="flex:1;">
             <div>
                <b>NGƯỜI NHẬN HÀNG</b>
             </div>
             <div>(Ký, họ tên)</div>
          </div>
       </div>
    </div>
    </div>
 </div>
 <br/><br/>
 </section>
 `;
  return template;
};

/*
  ${
   !isRaw
     ? `<section style="position:relative; ${PRINT_PAGE_HEIGHT} page-break-after: always;"> </section>`
     : ''
 }
*/

const genOrderTemplateTwoSide = (
  order,
  batch,
  splitIndex,
  numOfPage,
  isTotalInPage1,
  base64Data,
) => {
  const batchDate = moment(batch?.createdAt);
  console.log(numOfPage, splitIndex, order?.items);
  const template = `<section data-id="${
    order?.id
  }" style="position:relative; ${PRINT_PAGE_HEIGHT} page-break-after: right;">
  <div  id="page-${
    order.id
  }"  style="width: 800px; ${PRINT_PAGE_HEIGHT} padding: 40px; font-size: 12px; display: flex; flex-direction: column;">
     <div style="flex-grow: 2;">
        <div style="display:flex;justify-content: space-between;">
           <div style="display:flex;padding: 10px;  justify-content: space-between;">
           <img  height="30px" src="${
             base64Data || order?.chainStore?.logo || routineLogo
           }" style="object-fit: contain; margin-top: 20px; margin-right: 20px;" />
           <div style="text-align: left;font-size: 11px; flex-grow: 2;display:flex; align-items:flex-start; flex-direction:column; justify-content:center;">
              <div>
                 <strong>${order?.chainStore?.name || 'routine'} Vietnam (${
                   order?.chainStore?.siteUrl || 'routine.com.vn'
                 })</strong> Thuộc quyền sở hữu của ${
                   order?.chainStore?.data?.companyName ||
                   'CÔNG TY TM DV TỔNG HỢP HOÀN VŨ'
                 }
      </div>
              <div>${
                order?.chainStore?.data?.address ||
                '294 Hai Bà Trưng, P. Tân Định Q1, TP.HCM'
              }</div>
              <div style="display:flex;">
                 <div style="font-size: 11px; display:flex; align-items:center;">
                    ĐT<span>:</span> ${
                      order?.chainStore?.data?.phoneNumber || '18006035'
                    }
                 </div>
                 <div style="font-size: 11px; display:flex; align-items:center;margin-left: 10px;">
                    Email<span>:</span> ${
                      order?.chainStore?.data?.email || 'support@routine.com.vn'
                    }
                 </div>
              </div>
           </div>
        </div>
        <div style="margin-left: 20px;max-width: 45%; display: flex;  text-align: center; flex-direction: column; justify-content: center; align-items: center;">
           <div>Mẫu số: 02-VT</div>
           <div>
              (Ban hành theo TT số 200/2014/TT-BTC ngày 22/12/2014 của Bộ Trưởng BCT)
           </div>
        </div>
     </div>
     <div style="margin: 14px 0px; display: flex; justify-content: space-between;">
        <div style="margin-top: 10px; text-align: left;">
           <div style="font-size:15px; margin-top: 10px;">Mã đơn hàng  <b>${
             order?.orderNumber
           }</b></div>
           <div style="font-size:15px; margin-top: 10px;">Mã OMS  <b>${
             order?.id
           }</b></div>
        </div>
        <div style="text-align:left;">
           <canvas id="sale-order-id-${
             order?.id
           }" class="barcode-delivery-img"></canvas>
           <div style="text-align: center;font-size:15px;">${
             order?.saleOrderId
           }</div>
        </div>
     </div>
     <div>
        <div style="font-size: 20px; font-weight: bold; text-align:center;">PHIẾU XUẤT KHO</div>
        <div style="text-align:center;">
           Ngày ${batchDate.format('D')} tháng ${batchDate.format(
             'M',
           )} năm ${batchDate.format('YYYY')}
        </div>
     </div>
     <br/>
     <div  style="display:flex; align-items:center; justify-content: space-between;">
        <div  style='text-align: left;'>
           Đơn vị vận chuyển: <b>${order?.partner?.name}</b>
           <div>
              Địa chỉ: ${order?.address?.addressLine1 || ''}, ${
                order?.address?.addressLine2 || ''
              }, ${order?.address?.ward || ''}, ${order?.address?.district || ''}, ${
                order?.address?.province || ''
              }
           </div>
        </div>
        
     </div>
     <br />
     <div  style='text-align: left;'>
        Kho xuất: ${order?.location?.id} - ${order?.location?.name}
     </div>

     <div style="display: flex; margin-top: 10px; align-items: flex-end;">
         <div style="max-width: 100px; margin-top: 10px;">
         <canvas class="site-qrcode-img" id="site-url-${order?.id}" />
         </div>
         <div style="margin-top: 20px; padding: 0px 20px; text-align: left;">
            Quý khách vui lòng scan QR code hoặc truy cập https://${
              order?.chainStore?.siteUrl || 'routine.com.vn'
            }/help-center/questions để tham khảo quy định đổi trả sản phẩm
         </div>
     </div>
     <table style="width: 100%; border: 1px solid black; border-collapse: collapse; margin-top: 20px;">
        <tr>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 30px;">STT</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 120px;">Barcode</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 70px;">Loại</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 80px;">Mã số</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse;">Tên hàng</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Màu</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Size</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">DVT</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 60px;">Số lượng</th>
           <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Ghi chú</th>
        </tr>
        ${order?.items
          ?.slice(0, splitIndex[0])
          ?.map(
            (e, index) =>
              `<tr class="${order?.id}-item" key="${index}">
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
              ${index + 1}
            </td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
              ${(e?.variant?.barCode || e?.barCode || e?.barcode || '')
                ?.split(',')
                ?.map((barCode) => `<div>${barCode}</div>`)
                ?.join('')}
            </td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
              ${
                e?.product?.productType?.detail?.find(
                  (e) => e?.langCode === 'vi',
                )?.name ||
                e?.product?.productType?.detail?.find(
                  (e) => e?.langCode === 'en',
                )?.name ||
                e?.product?.productType?.slug ||
                ''
              }
            </td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
              e?.ItemId || ''
            }</td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
              e?.ItemDescription || ''
            }</td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;"></td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
              e?.VariantId || ''
            }</td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getUom(
              e,
            )}</td>
            <td style="text-align:right; padding-right: 10px; border: 1px solid black;border-collapse: collapse;">${
              e?.quantity
            }</td>
            <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getLotDateAlertNote(
              e?.variant,
            )}</td>
          </tr>`,
          )
          .join('')}
        
     </table>
     ${
       isTotalInPage1
         ? `<table style="width: 100%; border-collapse: collapse;margin-top: -1px; ">
       <tfoot>
          <tr>
             <td style="border: 1px solid black;border-collapse: collapse; text-align:center; padding:10px 5px;">
                <b>Tổng Cộng</b>
             </td>
             <td style="border: 1px solid black;border-collapse: collapse; width: 60px; text-align:right;">
                <div style="padding-right: 10px;">
                   <b>${getTotal(order?.items)}</b>
                </div>
             </td>
             <td style="border: 1px solid black;border-collapse: collapse; width: 50px;"></td>
          </tr>
       </tfoot>
    </table>`
         : ''
     }
     </div>
     </section>

     ${
       numOfPage > 2 && splitIndex > 1
         ? `<section data-id="${
             order?.id
           }" style="position:relative; ${PRINT_PAGE_HEIGHT}">
<div  id="page-${
             order.id
           }-2"  style="width: 800px;  ${PRINT_PAGE_HEIGHT} padding: 40px; font-size: 12px; display: flex; flex-direction: column;">


<table style="width: 100%; border: 1px solid black; border-collapse: collapse; ">
<tr>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 30px;">STT</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 120px;">Barcode</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 70px;">Loại</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 80px;">Mã số</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse;">Tên hàng</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Màu</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Size</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">DVT</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 60px;">Số lượng</th>
   <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Ghi chú</th>
</tr>
${order?.items
  ?.slice(splitIndex[0], order?.items?.length)
  ?.map(
    (e, index) =>
      `<tr class="${order?.id}-item" key="${index}">
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
      ${splitIndex[0] + index + 1}
    </td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
      ${(e?.variant?.barCode || e?.barCode || e?.barcode || '')
        ?.split(',')
        ?.map((barCode) => `<div>${barCode}</div>`)
        ?.join('')}
    </td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
      ${
        e?.product?.productType?.detail?.find((e) => e?.langCode === 'vi')
          ?.name ||
        e?.product?.productType?.detail?.find((e) => e?.langCode === 'en')
          ?.name ||
        e?.product?.productType?.slug ||
        ''
      }
    </td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
      e?.ItemId || ''
    }</td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
      e?.ItemDescription || ''
    }</td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;"></td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
      e?.VariantId || ''
    }</td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getUom(
      e,
    )}</td>
    <td style="text-align:right; padding-right: 10px; border: 1px solid black;border-collapse: collapse;">${
      e?.quantity
    }</td>
    <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getLotDateAlertNote(
      e?.variant,
    )}</td>
  </tr>`,
  )
  .join('')}

</table>
</div>
</section>`
         : splitIndex.slice(0, splitIndex.length - 1).map(
             (_splitIndex, i) => `<section data-id="${
               order?.id
             }" style="position:relative; ${PRINT_PAGE_HEIGHT} page-break-after: ${
               i % 2 ? 'left' : 'right'
             };">
     <div  id="page-${
       order.id
     }-2"  style="width: 800px;  ${PRINT_PAGE_HEIGHT} padding: 40px; font-size: 12px; display: flex; flex-direction: column;">
   
   
     <table style="width: 100%; border: 1px solid black; border-collapse: collapse; ">
     <tr>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 30px;">STT</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 120px;">Barcode</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 70px;">Loại</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 80px;">Mã số</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse;">Tên hàng</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Màu</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Size</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">DVT</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 60px;">Số lượng</th>
        <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Ghi chú</th>
     </tr>
     ${order?.items
       ?.slice(_splitIndex, splitIndex[i + 1] || order?.items.length)
       ?.map(
         (e, index) =>
           `<tr class="${order?.id}-item" key="${index}">
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
           ${_splitIndex + index + 1}
         </td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
           ${(e?.variant?.barCode || e?.barCode || e?.barcode || '')
             ?.split(',')
             ?.map((barCode) => `<div>${barCode}</div>`)
             ?.join('')}
         </td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
           ${
             e?.product?.productType?.detail?.find((e) => e?.langCode === 'vi')
               ?.name ||
             e?.product?.productType?.detail?.find((e) => e?.langCode === 'en')
               ?.name ||
             e?.product?.productType?.slug ||
             ''
           }
         </td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
           e?.ItemId || ''
         }</td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
           e?.ItemDescription || ''
         }</td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;"></td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
           e?.VariantId || ''
         }</td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getUom(
           e,
         )}</td>
         <td style="text-align:right; padding-right: 10px; border: 1px solid black;border-collapse: collapse;">${
           e?.quantity
         }</td>
         <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getLotDateAlertNote(
           e?.variant,
         )}</td>
       </tr>`,
       )
       .join('')}
     
   </table>
   </div>
   </section>`,
           )
     }

     <section data-id="${
       order?.id
     }" style="position:relative; ${PRINT_PAGE_HEIGHT} page-break-after: always;">
  <div  id="page-${
    order.id
  }-x"  style="width: 800px; ${PRINT_PAGE_HEIGHT} padding: 40px; font-size: 12px; display: flex; flex-direction: column;">


  ${
    splitIndex[splitIndex.length - 1] < order?.items?.length &&
    order?.items?.slice(splitIndex[splitIndex.length - 1], order?.items?.length)
      ?.length !== 0 &&
    (splitIndex.length > 1 || (splitIndex.length === 1 && numOfPage === 2))
      ? `<table style="width: 100%; border: 1px solid black; border-collapse: collapse; margin-top: 20px;">
  <tr>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 30px;">STT</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 120px;">Barcode</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 70px;">Loại</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 80px;">Mã số</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse;">Tên hàng</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Màu</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Size</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">DVT</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 60px;">Số lượng</th>
     <th style="padding-bottom: 10px; padding-top: 10px; border: 1px solid black; border-collapse: collapse; width: 50px;">Ghi chú</th>
  </tr>
  ${order?.items
    ?.slice(splitIndex[splitIndex.length - 1], order?.items?.length)
    ?.map(
      (e, index) =>
        `<tr class="${order?.id}-item" key="${index}">
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
        ${splitIndex[splitIndex.length - 1] + index + 1}
      </td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
        ${(e?.variant?.barCode || e?.barCode || e?.barcode || '')
          ?.split(',')
          ?.map((barCode) => `<div>${barCode}</div>`)
          ?.join('')}
      </td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">
        ${
          e?.product?.productType?.detail?.find((e) => e?.langCode === 'vi')
            ?.name ||
          e?.product?.productType?.detail?.find((e) => e?.langCode === 'en')
            ?.name ||
          e?.product?.productType?.slug ||
          ''
        }
      </td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
        e?.ItemId || ''
      }</td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
        e?.ItemDescription || ''
      }</td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;"></td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${
        e?.VariantId || ''
      }</td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getUom(
        e,
      )}</td>
      <td style="text-align:right; padding-right: 10px; border: 1px solid black;border-collapse: collapse;">${
        e?.quantity
      }</td>
      <td style="padding-bottom:10px; padding-top: 10px;text-align: center; border: 1px solid black;border-collapse: collapse;">${getLotDateAlertNote(
        e?.variant,
      )}</td>
    </tr>`,
    )
    .join('')}
  
</table>`
      : ''
  }

     ${
       !isTotalInPage1
         ? `<table style="width: 100%; border-collapse: collapse;margin-top: -1px; ">
        <tfoot>
           <tr>
              <td style="border: 1px solid black;border-collapse: collapse; text-align:center; padding:10px 5px;">
                 <b>Tổng Cộng</b>
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 60px; text-align:right;">
                 <div style="padding-right: 10px;">
                    <b>${getTotal(order?.items)}</b>
                 </div>
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 50px;"></td>
           </tr>
        </tfoot>
     </table>`
         : ''
     }
     <br/>
     <div  style='text-align: left;'>
        Ghi chú: ${
          order?.note ||
          '...............................................................................................................................................................................................'
        }
     </div>
     <br />
    ${
      order?.promotionNote
        ? `<div  style='text-align: left;'>
    Ghi chú quà tặng:<b>${order?.promotionNote}</b>
  </div>`
        : ''
    }
     <div>
        <br/><br/>
        <div style="display: flex;  text-align: center;">
           <div style="flex:1;">
              <div><b>NHÂN VIÊN KHO</b></div>
              <div>(Ký, họ tên)</div>
           </div>
           <div style="flex:1;">
              <div>
                 <b>QUẢN LÝ KHO</b>
              </div>
              <div>(Ký, họ tên)</div>
           </div>
           <div style="flex:1;">
              <div>
                 <b>KẾ TOÁN KHO</b>
              </div>
              <div>(Ký, họ tên)</div>
           </div>
           <div  style="flex:1;">
              <div>
                 <b>NGƯỜI NHẬN HÀNG</b>
              </div>
              <div>(Ký, họ tên)</div>
           </div>
     </div>
     </div>
     
     </div>
  </section>
  `;
  return template;
};

/*
${
    numOfPage % 2
      ? ''
      : '<section style="position:relative; ${PRINT_PAGE_HEIGHT} page-break-after: always;"/>'
  }
*/
